import { getGraphqlClient } from "@/api/graphql/client.ts";

import { duplicateFormDataRuleGroupMutation } from "./mutations.ts";

export const duplicateFormDataRuleGroup = (id: string) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(duplicateFormDataRuleGroupMutation, { id });
};
